import { InlineMessage, InlineMessagePropTypes } from './InlineMessage';
import InlineMessageInformation from './variations/InlineMessageInformation';
import InlineMessageSuccess from './variations/InlineMessageSuccess';
import InlineMessageWarning from './variations/InlineMessageWarning';
import InlineMessageDestructive from './variations/InlineMessageDestructive';
import InlineMessageBeta from './variations/InlineMessageBeta';

export type { InlineMessagePropTypes };
export {
	InlineMessage,
	InlineMessageInformation,
	InlineMessageSuccess,
	InlineMessageWarning,
	InlineMessageDestructive,
	InlineMessageBeta,
};
